module.exports = __webpack_public_path__ + "img/ltkstyletip-3x.db53b78.jpg";